module.exports = "/src/views/games/other/images/maps/mafia2.png";